import { LegalComponent } from './legal/legal.component';
import { ServicesComponent } from './services/services.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { AppMainComponent } from './app-main.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
const routes: Routes = [
  {
    path: '',
    component: AppMainComponent,
    data: {
      title: "Blouberg Physio"
    }
  },
  {
    path: 'appointments',
    component: AppointmentsComponent,
    data: {
      title: "Appointments"
    }
  },
  {
    path: 'legal',
    component: LegalComponent,
    data: {
      title: "Legal Matters"
    }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LayoutsRoutingModule { }
